import TrovaLogo from '../TrovaLogo/TrovaLogo';
import * as Styled from './NavbarStyles';
import React, { useState } from 'react';
import auth from '../../services/authentication';
import Avatar from '../Avatar/Avatar';
import Notifications from '../Notifications/Notifications';
import burgerIcon from '../../../images/burger-icon.svg';
import OutsideAlerter from '../../hooks/OutsideAlerter';

interface NavbarProps{
  title?: string,
  links?: Array<NavLinkProps>
}

interface NavLinkProps{
  title: string,
  link: string,
  external?: boolean;
}

const Navbar = ({ title, links }:NavbarProps) => {
  const isAuth = auth.isAuthenticated();
  const [dropOpen, setDropOpen] = useState(false);

  const toggleDrop = () => {
    setDropOpen(!dropOpen)
  }
  const closeMenu = () => {
    setDropOpen(false);
  }
  return (
    <Styled.Nav>
      <Styled.ContentWrapper>
        <Styled.LeftSide>
          <TrovaLogo hasText />
          {title &&
          <Styled.PageTitle>
            {title}
          </Styled.PageTitle>
          }
        </Styled.LeftSide>
        <Styled.RightSide>
          <div className="d-none d-lg-block">
            {links && links.map(l => !l.external ? (
              <Styled.NavbarLink to={l.link} key={l.link}>
                {l.title}
              </Styled.NavbarLink>
            ): (
              //@ts-ignore
              <Styled.NavbarLink as="a" href={l.link} key={l.link} target="_blank">
                {l.title}
              </Styled.NavbarLink>
            ))}
          </div>
          {isAuth ? (
            <>
              <Avatar hasDrop/>
              <Notifications />
              {/*<BurgerMenu />*/}
            </>
          ) : (
            <Styled.SignInBtn href="/signin-beta" className="d-none d-sm-flex">
              Sign In
            </Styled.SignInBtn>
          )}
          <OutsideAlerter setFunction={closeMenu}>
            <Styled.DropWrapper className="d-lg-none">
              <Styled.StyledImg
                src={burgerIcon}
                alt="Burger icon menu"
                onClick={toggleDrop}
              />
              <Styled.Menu className={dropOpen ? 'open' : ''}>
                {links && links.map(l => !l.external ? (
                  <Styled.MenuItem>
                    <Styled.NavbarLink to={l.link} key={l.link}>
                      {l.title}
                    </Styled.NavbarLink>
                  </Styled.MenuItem>
                ): (
                  //@ts-ignore
                  <Styled.MenuItem>
                    <Styled.NavbarLink as="a" href={l.link} key={l.link} target="_blank">
                      {l.title}
                    </Styled.NavbarLink>
                  </Styled.MenuItem>
                ))}
                {!isAuth && (
                  <Styled.SignInBtn href="/signin-beta" className="d-sm-none">
                    Sign In
                  </Styled.SignInBtn>
                )}
              </Styled.Menu>
            </Styled.DropWrapper>
          </OutsideAlerter>
        </Styled.RightSide>
      </Styled.ContentWrapper>
    </Styled.Nav>
  )
}

export default Navbar;